export default __webpack_public_path__ + "static/media/ux-iml-cover.57f53aab.png";